/* global $ */

class SpMenuButton {
  constructor() {
    this.$spMenuButton = $('.SpMenuButton');
    this.$logo = $('.HeaderLogo');

    this.$spMenuButton.on('click', () => {
      if (!this.$spMenuButton.hasClass('SpMenuButton--open')) {
        this.$spMenuButton.addClass('SpMenuButton--open');
        this.$logo.addClass('HeaderLogo--spMenuShow');
      } else {
        this.$spMenuButton.removeClass('SpMenuButton--open');
        this.$logo.removeClass('HeaderLogo--spMenuShow');
      }
    });
  }
}

export default SpMenuButton;
